import Typography from "@mui/material/Typography";
import classNames from "classnames";
import { useFormContext, useWatch } from "react-hook-form";
import { ExtractionQuery, PipelineConfig } from "../../../interfaces/doc";
import ArrayField from "./ArrayFields";
import {
  filterDisplayExtractionQueries,
  getField,
  getResultDefault,
} from "./ResultFormUtils";

export const ExtractionField: React.FC<{ query: ExtractionQuery }> = ({
  query,
}) => {
  const [parsing_type, custom_schema, enum_value] = useWatch({
    name: [
      `extraction.${query.id}.parsing_type`,
      `extraction.${query.id}.custom_schema`,
      `extraction.${query.id}.enum_value`,
    ],
  });
  const FormField = getField(parsing_type, custom_schema, enum_value);
  const getDefaultValue = () => getResultDefault(parsing_type, custom_schema);
  const getContent = () => {
    if ("many" in query && query.many) {
      return (
        <ArrayField
          extractionId={query.id}
          FormField={FormField}
          getDefaultValue={getDefaultValue}
        />
      );
    } else {
      return <FormField extractionId={query.id} />;
    }
  };
  return (
    <div className="flex flex-col gap-1">
      <Typography
        component="div"
        className={classNames("font-semibold flex items-center mb-2")}
      >
        {query.name}
      </Typography>
      {getContent()}
    </div>
  );
};

const ExtractionForm: React.FC<{ config: PipelineConfig }> = ({ config }) => {
  const { watch } = useFormContext();
  const classification = watch("classification");
  return (
    <>
      {!!config.extraction &&
        filterDisplayExtractionQueries(
          config.extraction.queries,
          classification
        ).map((query) => <ExtractionField key={query.id} query={query} />)}
    </>
  );
};

export default ExtractionForm;
